import script from "./VouchersOverviewCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersOverviewCard.vue?vue&type=script&setup=true&lang=ts"

import "./VouchersOverviewCard.vue?vue&type=style&index=0&id=081fb47e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081fb47e"]])

export default __exports__